(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["buy-buttons"] && !Shopify.designMode) return;
  try {
    (() => {
    if (window.__cordaroysInstallmentsInit) return;
    window.__cordaroysInstallmentsInit = true;

    const LOADED_ATTR = 'data-terms-loaded';
    const PENDING_ATTR = 'data-terms-pending';
    const OBSERVED_FLAG = 'cordaroysInstallmentsObserved';
    const PENDING_FALLBACK_DELAY = 1800;
    const TERMS_LIFECYCLE_EVENTS = ['shopify:payment-terms:loaded', 'shopify:payment-terms:rendered'];
    const PLACEHOLDER_DATA_KEY = 'installmentsPlaceholderHeight';

    const getContainer = (termsEl) => termsEl?.closest?.('.installments') ?? null;
    const getPlaceholder = (container) => container?.querySelector?.('.installments__placeholder') ?? null;

    const ensurePlaceholderSeeded = (container) => {
      if (!container) return;
      const dataset = container.dataset;
      if (!dataset || dataset[PLACEHOLDER_DATA_KEY]) return;
      const inlineValue = container.style?.getPropertyValue('--installments-placeholder-height')?.trim();
      if (inlineValue) {
        dataset[PLACEHOLDER_DATA_KEY] = inlineValue;
        return;
      }
      const placeholder = getPlaceholder(container);
      const rect = placeholder?.getBoundingClientRect?.();
      if (rect && rect.height > 0) {
        dataset[PLACEHOLDER_DATA_KEY] = `${Math.ceil(rect.height)}px`;
      }
    };

    const applyStoredPlaceholderHeight = (container) => {
      if (!container) return;
      const storedValue = container.dataset?.[PLACEHOLDER_DATA_KEY];
      if (storedValue) {
        container.style.setProperty('--installments-placeholder-height', storedValue);
      }
    };

    const setPlaceholderHeight = (container, termsEl) => {
      if (!container || !termsEl) return;
      const rect = termsEl.getBoundingClientRect?.();
      if (rect && rect.height > 0) {
        const height = `${Math.ceil(rect.height)}px`;
        container.style.setProperty('--installments-placeholder-height', height);
        container.dataset[PLACEHOLDER_DATA_KEY] = height;
      }
    };

    const setPendingState = (container, isPending) => {
      if (!container) return;
      if (isPending) {
        applyStoredPlaceholderHeight(container);
        container.setAttribute(PENDING_ATTR, 'true');
      } else {
        container.removeAttribute(PENDING_ATTR);
      }
    };

    const schedulePendingFallback = (container) => {
      if (!container) return;
      window.setTimeout(() => {
        if (!container.isConnected) return;
        if (!container.querySelector('shopify-payment-terms')) {
          container.removeAttribute(LOADED_ATTR);
          setPendingState(container, false);
        }
      }, PENDING_FALLBACK_DELAY);
    };

    const markLoading = (termsEl) => {
      const container = getContainer(termsEl);
      if (!container) return;
      ensurePlaceholderSeeded(container);
      applyStoredPlaceholderHeight(container);
      container.removeAttribute(LOADED_ATTR);
      setPendingState(container, true);
      schedulePendingFallback(container);
    };

    const markLoaded = (termsEl) => {
      const container = getContainer(termsEl);
      if (!container) return;
      setPlaceholderHeight(container, termsEl);
      container.setAttribute(LOADED_ATTR, 'true');
      setPendingState(container, false);
    };

    const observeShadowContent = (termsEl) => {
      const root = termsEl.shadowRoot;
      if (!root) return;
      if (termsEl.dataset.cordaroysShadowObserved === 'true') return;
      termsEl.dataset.cordaroysShadowObserved = 'true';
      const observer = new MutationObserver(() => {
        const hasContent = root.innerHTML.trim() !== '';
        if (hasContent) {
          observer.disconnect();
          markLoaded(termsEl);
        } else {
          markLoading(termsEl);
        }
      });
      observer.observe(root, { childList: true, subtree: true });
    };

    const markWhenReady = (termsEl) => {
      if (!(termsEl instanceof HTMLElement)) return;
      if (termsEl.dataset[OBSERVED_FLAG] === 'true') return;
      termsEl.dataset[OBSERVED_FLAG] = 'true';

      markLoading(termsEl);

      const tryImmediate = () => {
        const root = termsEl.shadowRoot;
        if (root && root.innerHTML.trim() !== '') {
          markLoaded(termsEl);
          return true;
        }
        return false;
      };

      if (tryImmediate()) {
        return;
      }

      if (termsEl.shadowRoot) {
        observeShadowContent(termsEl);
      }

      let rafAttempts = 0;
      const maxAttempts = 10;
      const rafCheck = () => {
        if (tryImmediate()) {
          return;
        }
        rafAttempts += 1;
        if (rafAttempts < maxAttempts) {
          requestAnimationFrame(rafCheck);
        }
      };
      requestAnimationFrame(rafCheck);

      const onceLoaded = () => markLoaded(termsEl);
      TERMS_LIFECYCLE_EVENTS.forEach((eventName) => {
        termsEl.addEventListener(eventName, onceLoaded, { once: true });
      });

      // The rAF burst above covers ~10 frames and the shadow observer only
      // attaches if shadowRoot already exists. In the quick-add modal the
      // widget starts loading when the shopper opens it, so it regularly
      // finishes after both expire - the placeholder was then stranded above
      // a fully loaded widget forever. Keep checking, and attach the shadow
      // observer as soon as the root appears.
      const POLL_MS = 250;
      const MAX_WAIT_MS = 15000;
      let waited = 0;
      const poll = window.setInterval(() => {
        waited += POLL_MS;
        if (!termsEl.isConnected || tryImmediate() || waited >= MAX_WAIT_MS) {
          window.clearInterval(poll);
          return;
        }
        observeShadowContent(termsEl);
      }, POLL_MS);
    };

    const processExisting = () => {
      document.querySelectorAll('shopify-payment-terms').forEach(markWhenReady);
    };

    // This block's installments form is rendered once from
    // `closest.product.selected_or_first_available_variant` and is never
    // re-rendered on a variant change - unlike blocks/price.liquid's copy,
    // which <product-price> rebuilds every time. Its hidden input therefore
    // stayed pinned to the first available variant, so a King mattress
    // advertised the Twin monthly payment. Verified on the live PDP: with
    // King selected the add-to-cart form read the King id while this form
    // still read Twin's.
    //
    // The add-to-cart form's own variant input does track the selection, so
    // it's the source of truth here; mirror it in and re-point the widget.
    const getSelectedVariantId = () => {
      const input = document.querySelector(
        'product-form-component form[data-type="add-to-cart-form"] input[name="id"]'
      );
      const value = input && input.value ? String(input.value).trim() : '';
      return value || null;
    };

    const syncInstallmentsVariant = () => {
      const nextId = getSelectedVariantId();
      if (!nextId) return;

      document.querySelectorAll('.installments form.payment-terms').forEach((form) => {
        const hidden = form.querySelector('input[name="id"]');
        if (!hidden || hidden.value === nextId) return;

        hidden.value = nextId;
        hidden.setAttribute('value', nextId);

        // Shopify's widget renders from this attribute; changing it is what
        // makes it recalculate. Skipped when it already agrees so we never
        // trigger a needless re-render.
        const terms = form.querySelector('shopify-payment-terms');
        if (terms && terms.getAttribute('variant-id') !== nextId) {
          terms.setAttribute('variant-id', nextId);
        }
      });
    };

    // The selection lands asynchronously (the theme re-renders parts of the
    // section first), so re-check across a couple of frames and once more
    // after the swap has certainly settled.
    const scheduleInstallmentsSync = () => {
      window.requestAnimationFrame(() => window.requestAnimationFrame(syncInstallmentsVariant));
      window.setTimeout(syncInstallmentsVariant, 350);
    };

    const observeVariantChanges = () => {
      document.addEventListener('change', (event) => {
        const target = event.target;
        if (!(target instanceof HTMLElement)) return;
        if (target.matches('input[type="radio"], select')) scheduleInstallmentsSync();
      });

      // Covers pickers that swap variants without firing a change event on a
      // control we can see (swatch buttons, deep links).
      document.addEventListener('variant:update', scheduleInstallmentsSync);

      syncInstallmentsVariant();
    };

    const observeNewElements = () => {
      const observer = new MutationObserver((mutations) => {
        for (const mutation of mutations) {
          mutation.addedNodes.forEach((node) => {
            if (!(node instanceof HTMLElement)) return;
            if (node.matches('shopify-payment-terms')) {
              markWhenReady(node);
            } else {
              node.querySelectorAll?.('shopify-payment-terms').forEach(markWhenReady);
            }
          });

          const container =
            mutation.target instanceof HTMLElement ? mutation.target.closest('.installments') : null;
          if (!container) continue;

          const removedHasTerms = Array.from(mutation.removedNodes).some(
            (removed) =>
              removed instanceof HTMLElement &&
              (removed.matches('shopify-payment-terms') || removed.querySelector?.('shopify-payment-terms'))
          );

          if (removedHasTerms) {
            container.removeAttribute(LOADED_ATTR);
            setPendingState(container, true);
            schedulePendingFallback(container);
          }
        }
      });
      observer.observe(document.body, { childList: true, subtree: true });
    };

    const init = () => {
      const start = () => {
        const onLifecycleEvent = (event) => {
          const target = event.target;
          if (target instanceof HTMLElement && target.matches('shopify-payment-terms')) {
            markLoaded(target);
          }
        };

        TERMS_LIFECYCLE_EVENTS.forEach((eventName) => {
          document.addEventListener(eventName, onLifecycleEvent);
        });

        processExisting();
        observeNewElements();
        observeVariantChanges();
      };

      if (customElements.get('shopify-payment-terms')) {
        start();
      } else {
        customElements.whenDefined('shopify-payment-terms').then(start);
      }
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init, { once: true });
    } else {
      init();
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["footprint-mini"] && !Shopify.designMode) return;
  try {
    class FootprintMini extends HTMLElement {
    static SCALE = 0.8;
    static CLEARANCE_IN = 10;
    static CHAIR_CX = 44;
    static CHAIR_CY = 46;
    static BED_CX = 112;
    static BED_CY = 48;

    connectedCallback() {
      this.circle = this.querySelector('[data-fpm-circle]');
      this.zone = this.querySelector('[data-fpm-zone]');
      this.bed = this.querySelector('[data-fpm-bed]');
      this.pillow = this.querySelector('[data-fpm-pillow]');
      this.bedGroup = this.querySelector('[data-fpm-bedgroup]');
      this.chairText = this.querySelector('[data-fpm-chairtext]');
      this.bedText = this.querySelector('[data-fpm-bedtext]');
      if (!this.circle) return;

      this.sizes = {};
      (this.dataset.sizes || '').split(',').forEach((triple) => {
        const [name, floor, bed] = triple.split(':');
        if (!name || !parseFloat(floor)) return;
        const m = (bed || '').match(/(\d+)\s*[x×]\s*(\d+)/i);
        this.sizes[name.trim()] = {
          floor: parseFloat(floor),
          bedW: m ? parseFloat(m[1]) : 0,
          bedL: m ? parseFloat(m[2]) : 0,
        };
      });

      const title = this.dataset.currentTitle || '';
      const current = Object.keys(this.sizes).find((n) => title.includes(n));
      this.setSize(current || Object.keys(this.sizes)[0]);

      this.onTap = (event) => {
        const row = event.target.closest('[data-size-compare-select]');
        if (!row) return;
        const name = row.dataset.sizeCompareSelect;
        if (this.sizes[name]) this.setSize(name);
      };
      const scope = this.closest('dialog') || document;
      scope.addEventListener('click', this.onTap);
      this.scope = scope;
    }

    disconnectedCallback() {
      this.scope?.removeEventListener('click', this.onTap);
    }

    setSize(name) {
      const d = this.sizes[name];
      if (!d) return;
      const S = FootprintMini.SCALE;

      this.circle.setAttribute('r', (d.floor / 2) * S);
      this.zone.setAttribute('r', (d.floor / 2 + FootprintMini.CLEARANCE_IN) * S);
      this.chairText.textContent = d.floor + '" chair · ' + name;

      if (d.bedW && d.bedL) {
        const w = d.bedW * S;
        const h = d.bedL * S;
        const x = FootprintMini.BED_CX - w / 2;
        const y = FootprintMini.BED_CY - h / 2;
        this.bed.setAttribute('x', x);
        this.bed.setAttribute('y', y);
        this.bed.setAttribute('width', w);
        this.bed.setAttribute('height', h);
        this.pillow.setAttribute('x', x + 3);
        this.pillow.setAttribute('y', y + 3);
        this.pillow.setAttribute('width', w - 6);
        this.pillow.setAttribute('height', 10);
        this.bedGroup.removeAttribute('hidden');
        this.bedText.textContent = d.bedW + '×' + d.bedL + '" bed inside';
      } else {
        this.bedGroup.setAttribute('hidden', '');
        this.bedText.textContent = 'chair only';
      }
    }
  }

  if (!customElements.get('footprint-mini')) {
    customElements.define('footprint-mini', FootprintMini);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["size-compare"] && !Shopify.designMode) return;
  try {
    (() => {
    // Sizes are sibling products: the picker (.SiblingPicker) renders each
    // size as a product link. Find the option matching a size name, outside
    // this drawer.
    const findSizeOption = (size) => {
      const scopes = document.querySelectorAll(
        '.SiblingPickerGroup, .SiblingPicker, variant-picker-siblings-v2, [class*="variant-picker"]'
      );
      const match = (root) =>
        [...root.querySelectorAll('a, button, label, input')].find((el) => {
          if (el.closest('.size-compare')) return false;
          const text = (el.tagName === 'INPUT' ? el.value : el.textContent) || '';
          return text.trim().toLowerCase() === size.toLowerCase();
        });
      for (const scope of scopes) {
        const found = match(scope);
        if (found) return found;
      }
      // Fallback: any product link with exactly the size name as its text.
      return [...document.querySelectorAll('a[href*="/products/"]')].find((el) => {
        if (el.closest('.size-compare')) return false;
        return (el.textContent || '').trim().toLowerCase() === size.toLowerCase();
      }) || null;
    };

    // Rows whose size has no sibling in this fabric become informational.
    const markUnavailable = () => {
      document.querySelectorAll('[data-size-compare-select]').forEach((row) => {
        if (row.classList.contains('size-compare__row--current')) return;
        if (row.hasAttribute('data-size-compare-checked')) return;
        row.setAttribute('data-size-compare-checked', '');
        if (!findSizeOption(row.dataset.sizeCompareSelect)) {
          row.classList.add('size-compare__row--unavailable');
          const best = row.querySelector('.size-compare__best');
          if (best) best.textContent = 'Not available in this fabric';
        }
      });
    };
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', markUnavailable);
    } else {
      markUnavailable();
    }

    document.addEventListener('click', (event) => {
      const row = event.target.closest('[data-size-compare-select]');
      if (!row) return;

      if (
        row.classList.contains('size-compare__row--current') ||
        row.classList.contains('size-compare__row--unavailable')
      ) {
        row.closest('dialog')?.close();
        return;
      }

      const target = findSizeOption(row.dataset.sizeCompareSelect);
      if (target) {
        row.closest('dialog')?.close();
        target.click();
      }
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
